export const OPEN_GAME_ANIMATION_DURATION = 600
